// extracted by mini-css-extract-plugin
var _1 = "PointTooltip_arrows__ae651";
var _2 = "PointTooltip_content__adbbe";
var _3 = "PointTooltip_description__c3968";
var _4 = "PointTooltip_disabled__ec953";
var _5 = "PointTooltip_footer__8fc2c";
var _6 = "PointTooltip_image__ffc18";
var _7 = "PointTooltip_imageWrapper__9c243";
var _8 = "PointTooltip_inner__6dc58";
var _9 = "PointTooltip_mobile__4186d";
var _a = "PointTooltip_navigation__94eb0";
var _b = "PointTooltip_overlay__423a3";
var _c = "PointTooltip_root__c0548";
var _d = "PointTooltip_title__820d1";
export { _1 as "arrows", _2 as "content", _3 as "description", _4 as "disabled", _5 as "footer", _6 as "image", _7 as "imageWrapper", _8 as "inner", _9 as "mobile", _a as "navigation", _b as "overlay", _c as "root", _d as "title" }
